/* global gdAlertify */
import React, { useState } from 'react';
import Logo from '../assets/images/sk-logo.png';
import axiosInstance from '../config/axiosConfig';
import { useNavigate } from 'react-router-dom';

function RecuperarContrasena({ }) {
    const navigate = useNavigate();
    const [email, setEmail] = useState('');
    const [isLoading, setIsLoading] = useState(false);

    const handleRecuperar = (e) => {
        e.preventDefault();
        setIsLoading(true);

        axiosInstance.post('/recuperar-contrasena', { email })
            .then((response) => {
                setIsLoading(false);
                const result = response.data;
                
                if (result.error) {
                    gdAlertify.notiError(result.message);
                    return;
                }
                
                gdAlertify.notiSuccess('Revisa tu correo para recuperar tu contraseña');
                navigate("/")
            })
            .catch((error) => {
                setIsLoading(false);
                console.error(error);
                gdAlertify.notiError('Hubo un error en la solicitud');
            });
    };

    return (
        <div className='container d-flex justify-content-center align-items-center'>
            <div className="card mt-5">
                <div className="card-body">
                    <div className="login-container text-center">
                        <img src={Logo} alt="Logo Sk Medical" />
                        <h2>Recuperar Contraseña</h2>
                        <form onSubmit={handleRecuperar}>
                            <div className="mb-3">
                                <label htmlFor="email" className="form-label">Correo Electrónico</label>
                                <input
                                    type="email"
                                    id="email"
                                    className="form-control"
                                    value={email}
                                    onChange={(e) => setEmail(e.target.value)}
                                    required
                                />
                            </div>
                            <button type="submit" className="btn btn-primary" disabled={isLoading}>
                                {isLoading ? 'Enviando...' : 'Enviar Correo'}
                            </button>
                        </form>
                        <a type="recuperar-contraseña" className="btn" onClick={() => navigate("/")}>
                           Volver Al Inicio de sesión
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default RecuperarContrasena;
